import React from "react"
import {
  Date,
  FallBackDateTimeFrom,
  FallBackDateTimeTo,
  FallbackInputContainer,
  FallbackTimeWrapper,
  FallbackValue,
  Label
} from "./Input.styled"
import { ValidDateRange } from "lib/types/generated/graphql-types"
import dayjs from "dayjs"
import { ReactComponent as ClockIcon } from "images/icons/clock.svg"
import { ReactComponent as ChevronRight } from "images/icons/chevron-right.svg"

type Props = {
  label: string
  value?: string | undefined
  dateTime?: ValidDateRange
}

const FallbackInput = ({ label, value, dateTime }: Props) => {
  if (dateTime) {
    return (
      <FallbackInputContainer>
        <Label>{label}</Label>
        <FallbackTimeWrapper>
          <FallBackDateTimeFrom>
            <ClockIcon />
            <Date>{dayjs(dateTime.from).format("YYYY-MM-DD : HH:mm")}</Date>
          </FallBackDateTimeFrom>
          <FallBackDateTimeTo>
            <ChevronRight />
            <Date>{dayjs(dateTime.to).format("YYYY-MM-DD : HH:mm")}</Date>
          </FallBackDateTimeTo>
        </FallbackTimeWrapper>
      </FallbackInputContainer>
    )
  }

  return (
    <FallbackInputContainer>
      <Label>{label}</Label>
      <FallbackValue>{!value || value === "" ? "-" : value}</FallbackValue>
    </FallbackInputContainer>
  )
}

export default FallbackInput
